export default function cleanAndFormatNumber (input) {
    let value = String(input);
    // Remove any non-digit characters except for '.' (decimal point)
    let cleaned = value.replace(/[^\d.]/g, '');
    
    // Check if there is a decimal point
    let decimalIndex = cleaned.indexOf('.');
    
    // If there is a decimal point and there are more than 2 digits after it, truncate to 2 decimal places
    if (decimalIndex !== -1) {
        let integerPart = cleaned.substring(0, decimalIndex);
        let decimalPart = cleaned.substring(decimalIndex + 1);
        cleaned = integerPart + '.' + decimalPart.slice(0, 2); // keep only up to 2 decimal places
    }

    // Return the cleaned and formatted number
    return cleaned;
};